module.exports = __webpack_public_path__ + "img/logo-ecart.bad135da.svg";